import React, { useState, forwardRef } from 'react';
import {
  Autocomplete,
  Grid,
  Button,
  InputAdornment,
  InputBase,
  Menu,
  MenuItem as MuiMenuItem,
  menuItemClasses,
  styled,
  TextField,
  TextFieldProps,
  Tooltip,
  Chip,
} from '@mui/material';
import { Field, FieldProps, getIn } from 'formik';
import { ArrowDropDown } from '@mui/icons-material';
import { JItem } from '../../forms/jformik/jformik.types';
import { useJFormikContext } from '../jformik/jformik.context';
import { useBreakpointQuery } from '../../../utils';

export const FEmailFwdInput = forwardRef((jItem: JItem, ref) => {
  const { disabled = false, disableSubmitOnEnter = true } = useJFormikContext();
  const [inputValue, setInputValue] = useState<string>('');
  const [inputValueCC, setInputValueCC] = useState<string>('');
  const [inputValueBCC, setInputValueBCC] = useState<string>('');
  const [showCC, setShowCC] = useState<boolean>(false);
  const [showBCC, setShowBCC] = useState<boolean>(false);
  const smDown = useBreakpointQuery('sm-down');
  const [openTooltip, setOpenTooltip] = useState<boolean | undefined>(
    jItem?.tooltip?.open
  );
  const {
    multiple = false,
    freeSolo = false,
    freeSoloFormat,
    limitTags = 5,
    name,
    label,
    options,
    tooltip,
  } = jItem;
  return (
    <Field name={jItem.name} innerRef>
      {({
        field: { name, value },
        form: { touched, errors, setFieldValue, values, submitCount },
      }: FieldProps) => {
        return (
          <Grid
            container
            alignContent={'space-between'}
            sx={{
              paddingY: 0.9,
              borderBottom: theme =>
                `1px solid ${theme.palette.action.disabledBackground}`,
            }}
          >
            <Grid container xs={10}>
              <Grid item xs={12}>
                {/* <Autocomplete
                  multiple
                  freeSolo
                  fullWidth
                  options={[]}
                  defaultValue={[]}
                  renderTags={(value: readonly string[], getTagProps: any) => {
                    const splitValues = value.map(o => o.split(/[,;]+/)).flat(2)
                    return splitValues.map((option: string, index: number) => (
                      <EmailChip label={option} {...getTagProps({ index })} />
                    ));
                  }}
                  renderInput={params => (
                    <TextField
                      {...params}
                      onKeyPress={(e) => { disableSubmitOnEnter && e.key === 'Enter' && e.preventDefault() }}
                      sx={{
                        paddingLeft: 4.5,
                        paddingRight: 1,
                        boxSizing: 'border-box',
                        '.MuiOutlinedInput-root': {
                          padding: 0,
                        },
                        '.MuiOutlinedInput-notchedOutline': {
                          borderWidth: `0px !important`,
                        },
                      }}
                      InputProps={{
                        ...params.InputProps,
                        sx: {
                          color: theme => theme.palette.primary.main,
                          fontWeight: 400,
                          fontSize: 14,
                        },
                        startAdornment: (
                          <>
                            <InputAdornment
                              position="start"
                            // sx={{
                            //   color: theme => theme.palette.text.disabled,
                            // }}
                            >
                              {label}:{' '}
                            </InputAdornment>
                            {params.InputProps.startAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                  value={value}
                  onChange={(event: any, newValue: any) => {
                    if (jItem.freeSolo && typeof newValue === 'string') {
                      setFieldValue(name, freeSoloFormat ? freeSoloFormat(newValue) : { id: 0, label: newValue, name: newValue })
                    } else if (freeSolo && multiple) {
                      const newArray = newValue.map((value: any) => typeof value === 'string' ? freeSoloFormat ? freeSoloFormat(value) : ({ id: 0, label: value, name: value }) : value)
                      setFieldValue(name, newArray)
                    } else {
                      setFieldValue(name, newValue);
                    }
                  }}
                  inputValue={inputValue}
                  onInputChange={(event, inputValue) => {
                    const options = inputValue.split(/[, ]+/);

                    if (options.length > 1) {
                      setFieldValue(name,
                        value
                          .concat(options)
                          .map((x: any) => x?.trim())
                          .filter((x: any) => x)
                      );

                      setInputValue('');
                    } else {
                      setInputValue(inputValue);
                    }
                  }}
                  onBlur={(event: any) => {
                    const option = (event?.target?.value || '').trim();

                    if (option) {
                      setFieldValue(name, [...(value || []), option]);
                      setInputValue('');
                    }
                  }}
                /> */}
                <Autocomplete
                  disabled={disabled || jItem.disabled}
                  multiple={multiple}
                  freeSolo={freeSolo}
                  blurOnSelect={freeSolo ? 'mouse' : false}
                  limitTags={limitTags}
                  autoSelect
                  onChange={(event: any, newValue: any) => {
                    if (freeSolo && typeof newValue === 'string') {
                      setFieldValue(
                        name,
                        freeSoloFormat
                          ? freeSoloFormat(newValue)
                          : { id: 0, label: newValue, name: newValue }
                      );
                    } else if (freeSolo && multiple) {
                      const newArray = newValue.map((value: any) =>
                        typeof value === 'string'
                          ? freeSoloFormat
                            ? freeSoloFormat(value)
                            : { id: 0, label: value, name: value }
                          : value
                      );
                      setFieldValue(name, newArray);
                    } else {
                      setFieldValue(name, newValue);
                    }
                  }}
                  onInputChange={(event: any, newInputValue: string) => {
                    if (
                      newInputValue.endsWith(',') ||
                      newInputValue.endsWith(';') ||
                      newInputValue.endsWith(' ')
                    ) {
                      event.target.blur();
                      event.target.focus();
                    }
                  }}
                  value={value}
                  options={
                    options
                      ? typeof options === 'function'
                        ? options(values)
                        : options
                      : []
                  }
                  getOptionLabel={(option: any) => {
                    if (typeof option === 'string') {
                      return option;
                    } else {
                      return (
                        option?.label ||
                        option?.title ||
                        option?.name ||
                        option?.email ||
                        ''
                      );
                    }
                  }}
                  // renderTags={(value: readonly string[], getTagProps: any) => {
                  //   const splitValues = value.map((ops: string) => ops?.split(/[,;\s]+/))?.flat(2)
                  //   return splitValues.map((option: string, index: number) => {
                  //     return (<Chip label={option} {...getTagProps({ index })} />)
                  //   });
                  // }}
                  renderInput={(params: TextFieldProps) => {
                    if (tooltip) {
                      return (
                        <Tooltip {...{ ...tooltip, open: openTooltip }}>
                          <TextField
                            {...params}
                            onKeyPress={e => {
                              disableSubmitOnEnter &&
                                e.key === 'Enter' &&
                                e.preventDefault();
                            }}
                            onFocus={() => {
                              if (openTooltip) {
                                setOpenTooltip(false);
                              }
                            }}
                            label={label}
                            variant="outlined"
                            // size={smDown ? 'small' : 'medium'}
                            error={
                              !!(
                                getIn(errors, name) &&
                                (getIn(touched, name) || submitCount)
                              )
                            }
                            helperText={
                              jItem.jItemProps?.helperText
                                ? jItem.jItemProps?.helperText
                                : getIn(touched, name) || submitCount
                                ? getIn(errors, name)
                                : null
                            }
                          />
                        </Tooltip>
                      );
                    } else {
                      return (
                        <TextField
                          {...params}
                          onKeyPress={e => {
                            disableSubmitOnEnter &&
                              e.key === 'Enter' &&
                              e.preventDefault();
                          }}
                          sx={{
                            paddingLeft: 4.5,
                            paddingRight: 1,
                            boxSizing: 'border-box',
                            '.MuiOutlinedInput-root': {
                              padding: 0,
                            },
                            '.MuiOutlinedInput-notchedOutline': {
                              borderWidth: `0px !important`,
                            },
                          }}
                          InputProps={{
                            ...params.InputProps,
                            sx: {
                              color: theme => theme.palette.primary.main,
                              fontWeight: 400,
                              fontSize: 14,
                            },
                            startAdornment: (
                              <>
                                <InputAdornment position="start">
                                  {label}:{' '}
                                </InputAdornment>
                                {params?.InputProps?.startAdornment}
                              </>
                            ),
                          }}
                        />
                      );
                    }
                  }}
                  autoHighlight
                  {...jItem.jItemProps}
                />
              </Grid>
            </Grid>
          </Grid>
        );
      }}
    </Field>
  );
});

interface EmailChipProps {
  label?: string;
}

const EmailChip = ({ label = 'No email' }: EmailChipProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Grid>
      <Button
        endIcon={
          <ArrowDropDown
            sx={{
              marginLeft: -0.5,
            }}
          />
        }
        onClick={handleClick}
        sx={{
          fontWeight: 400,
          textTransform: 'unset',
          marginRight: 0.5,
        }}
      >
        {label}
      </Button>

      <Menu
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        onClose={handleClose}
        PaperProps={{
          sx: {
            minWidth: 120,
          },
        }}
      >
        <MenuItem onClick={handleClose}>Option 1</MenuItem>
        <MenuItem onClick={handleClose}>Option 2</MenuItem>
        <MenuItem onClick={handleClose}>Option 3</MenuItem>
      </Menu>
    </Grid>
  );
};

const MenuItem = styled(MuiMenuItem)(({ theme }) => ({
  [`&.${menuItemClasses.root}`]: {
    fontSize: 14,
    color: theme.palette.primary.main,
  },
}));
